import styled from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
  padding: 20px 0 20px 0;

  ${media.tabletDown} {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 12px 0;
  }

  ${media.mobileOnly} {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 10px 0;
  }
`

export const MetricCard = styled.div`
  padding: 12px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};

  ${media.tabletDown} {
    padding: 12px;
  }

  ${media.mobileOnly} {
    padding: 10px;
  }
`

export const MetricHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;

  ${media.tabletDown} {
    gap: 5px;
    margin-bottom: 5px;
  }
`

export const MetricIcon = styled.div<{ $color?: string }>`
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: ${({ $color, theme }) => ($color || theme.colors.primary) + '15'};
  color: ${({ $color, theme }) => $color || theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;

  ${media.tabletDown} {
    width: 23px;
    height: 23px;
    font-size: 12px;
  }
`

export const MetricTitle = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};

  ${media.tabletDown} {
    font-size: 11px;
  }
`

export const MetricValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};

  ${media.tabletDown} {
    font-size: 15px;
  }

  ${media.mobileOnly} {
    font-size: 13px;
  }
`

export const MetricSubtext = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 3px;

  ${media.tabletDown} {
    font-size: 10px;
    margin-top: 2px;
  }
`
